export default "__VITE_ASSET__bpjT9zfg__"